export const getProfileReviewQueueState = ({
  loading,
  error,
  receiptsReady,
  scoped,
  pendingCount,
}) => {
  if (error)
    return {
      status: "failed",
      title: "Review could not be loaded",
      subtitle: "We could not check which items still need review.",
    };
  if (loading || !receiptsReady)
    return {
      status: "loading",
      title: "Loading review…",
      subtitle: "Checking saved suggestions and review decisions.",
    };
  if (pendingCount > 0)
    return {
      status: "pending",
      title: "Needs your review",
      subtitle: `${pendingCount} item${pendingCount === 1 ? " requires" : "s require"} review`,
    };
  if (scoped)
    return {
      status: "scoped_empty",
      title: "No pending items for this update",
      subtitle: "You can check the full review queue below.",
    };
  return {
    status: "complete",
    title: "Review complete",
    subtitle: "All review decisions are up to date.",
  };
};
